import { useTypedSelector } from '@root/core/hooks/useTypedSelector';
import {
  bodyCompleteInbound,
  InitDetailInbound,
  InitialCompleteInboundType
} from '@root/state';
import {
  Button,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
  Spin,
  Table
} from 'antd';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { ColumnsType } from 'antd/lib/table';
import { useActions } from '@root/core/hooks/useActions';
import Popup from '@root/core/components/Popup';
import moment from 'moment';
import { Typography } from 'antd';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import inboundService from '../service/inbound';
import { Product } from '@root/modules/Sellers/Shipping/interfaces';

interface ParamType {
  id: string;
}

interface DataType {
  key: React.Key;
  id: number;
  deliveredDate: string;
  location: string;
  estimateQuantity: number;
  deliveredQuantity: number;
  availableQuantity: number;
  unavailableQuantity: number;
  inspectionResult: string;
  productName?: string;
  otherReason: string;
}

interface Inventory {
  availableQuantity: number;
  created_at: string;
  deliveredDt: Date;
  productId?: number;
  deliveredQuantity: number;
  estimatedQuantity: number;
  productName?: string;
  id: number;
  inspectionResult: string;
  otherReason: string;
  location: string;
  unAvailableQuantity: number;
  updated_at: string;
  otherResultDetail: string;
  product: Product;
}

interface body {
  location: string[];
  estimatedQuantity: number[];
  deliveredDate: string[];
  deliveredQuantity: number[];
  availableQuantity: number[];
  unavailableQuantity: number[];
  inspectionResult: string[];
  otherReason: string;
}
const { Text } = Typography;

interface TableCompleteProps {
  canEdit: boolean;
  commentId: number;
  editComplete: () => void;
}
const TableComplete = ({
  canEdit,
  commentId,
  editComplete
}: TableCompleteProps) => {
  const { id } = useParams<ParamType>();
  const { Option } = Select;
  const [other, setOther] = useState<number[]>([]);
  const columns: ColumnsType<DataType> = [
    {
      title: 'Product Name',
      dataIndex: 'productName'
    },
    {
      title: 'Delivered Date',
      dataIndex: 'deliveredDate'
    },
    {
      title: 'Location',
      dataIndex: 'location',
      width: '13%'
    },
    {
      title: 'Estimated Quantity',
      dataIndex: 'estimatedQuantity'
    },
    {
      title: 'Delivered Quantity',
      dataIndex: 'deliveredQuantity'
    },
    {
      title: 'Available Quantity',
      dataIndex: 'availableQuantity'
    },
    {
      title: 'Unavailable Quantity',
      dataIndex: 'unavailableQuantity'
    },
    {
      title: 'Inspection Result',
      dataIndex: 'inspectionResult'
    }
  ];
  const { data } = useTypedSelector<InitDetailInbound>(
    (state) => state.detailInboundReducer
  );

  const { completeLoading } = useTypedSelector<InitialCompleteInboundType>(
    (state) => state.completeInboundReducer
  );

  const [form] = Form.useForm();
  const { postInboundCompleteHandle } = useActions();
  const [body, setBody] = useState<bodyCompleteInbound>({
    importInformations: []
  });
  const [showModal, setShowModal] = useState<boolean>(false);

  const completeHandle = (values: body) => {
    const bodyImportInformations = [];
    for (let i = 0; i < data?.data?.products.length; i++) {
      if (other.length) {
        bodyImportInformations.push({
          productId: data?.data?.products[i].id,
          productName: data?.data?.products[i].productName,
          location: values?.location[i],
          estimatedQuantity: data?.data?.products[i].estimateQuantity,
          deliveredDt: new Date(values?.deliveredDate[i]).toUTCString(),
          deliveredQuantity: values?.deliveredQuantity[i],
          availableQuantity: values?.availableQuantity[i],
          unAvailableQuantity: values?.unavailableQuantity[i],
          inspectionResult: values?.inspectionResult[i],
          otherResultDetail: values?.otherReason[i]
        });
      } else {
        bodyImportInformations.push({
          productId: data?.data?.products[i].id,
          location: values?.location[i],
          productName: data?.data?.products[i].productName,
          estimatedQuantity: data?.data?.products[i].estimateQuantity,
          deliveredDt: new Date(values?.deliveredDate[i]).toUTCString(),
          deliveredQuantity: values?.deliveredQuantity[i],
          availableQuantity: values?.availableQuantity[i],
          unAvailableQuantity: values?.unavailableQuantity[i],
          inspectionResult: values?.inspectionResult[i]
        });
      }
    }
    const body: bodyCompleteInbound = {
      importInformations: bodyImportInformations
    };
    if (!showModal) {
      setShowModal(true);
      setBody(body);
    }
  };
  const handleOk = () => {
    postInboundCompleteHandle(id, body);
    setShowModal(false);
  };
  const handleCancel = () => {
    setShowModal(false);
  };

  const handleOnChange = (value: string, _: any, index: any) => {
    if (value === 'Others' && !other.includes(index)) {
      setOther([...other, index]);
    } else {
      if (other.indexOf(index) === -1) return;
      other.splice(other.indexOf(index), 1);
      setOther([...other]);
    }
  };

  const dataInfo: DataType[] = data?.data?.products.map(
    (item: DataType, index: number) => {
      return {
        ...item,
        key: item.id,
        id: item.id,
        productName: (
          <Form.Item name={['productName', index]}>
            <Text>{item.productName}</Text>
          </Form.Item>
        ),
        deliveredDate: (
          <Form.Item
            name={['deliveredDate', index]}
            rules={[{ required: true, message: 'Input delivered date!' }]}
          >
            <DatePicker placeholder="YYYY.MM.DD 00:00:00" />
          </Form.Item>
        ),
        location: (
          <Form.Item
            name={['location', index]}
            rules={[{ required: true, message: 'Input location!' }]}
          >
            <Input />
          </Form.Item>
        ),
        estimatedQuantity: (
          <Form.Item name={['estimatedQuantity', index]}>
            <InputNumber
              min={0}
              pattern="^[0-9]"
              defaultValue={item.estimateQuantity}
              disabled
            />
          </Form.Item>
        ),
        deliveredQuantity: (
          <Form.Item
            name={['deliveredQuantity', index]}
            rules={[
              { required: true, message: 'Input positive delivered quantity!' }
            ]}
          >
            <InputNumber min={0} />
          </Form.Item>
        ),
        availableQuantity: (
          <Form.Item
            name={['availableQuantity', index]}
            rules={[
              { required: true, message: 'Input positive available quantity!' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (
                    value >
                    getFieldValue(['deliveredQuantity', index]) -
                      getFieldValue(['unavailableQuantity', index])
                  ) {
                    return Promise.reject(
                      new Error(
                        'Unavailable Quantity must be less than Delivered Quantity - Available Quantity'
                      )
                    );
                  } else {
                    return Promise.resolve();
                  }
                }
              })
            ]}
          >
            <InputNumber min={0} />
          </Form.Item>
        ),
        unavailableQuantity: (
          <Form.Item
            name={['unavailableQuantity', index]}
            rules={[
              {
                required: true,
                message: 'Input positive unavailable quantity!'
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (
                    value >
                    getFieldValue(['deliveredQuantity', index]) -
                      getFieldValue(['availableQuantity', index])
                  ) {
                    return Promise.reject(
                      new Error(
                        'Available Quantity must be less than Delivered Quantity - unavailable Quantity'
                      )
                    );
                  } else {
                    return Promise.resolve();
                  }
                }
              })
            ]}
          >
            <InputNumber min={0} />
          </Form.Item>
        ),

        inspectionResult: (
          <>
            <Form.Item
              name={['inspectionResult', index]}
              rules={[{ required: true, message: 'Input inspection result!' }]}
            >
              <Select
                defaultValue="Select"
                onChange={(value, options) =>
                  handleOnChange(value, options, index)
                }
              >
                <Option value="defective">Defective</Option>
                <Option value="Quantity dismatch">Quantity mismatch</Option>
                <Option value="None">None</Option>
                <Option value="Others">Others</Option>
              </Select>
            </Form.Item>
            {other.includes(index) && (
              <div style={{ marginTop: '20px' }}>
                <Form.Item
                  name={['otherReason', index]}
                  rules={[
                    { required: true, message: 'Input inspection result!' },
                    {
                      max: 30,
                      message: `Input must be less than 30 characters!`
                    }
                  ]}
                >
                  {
                    <Input.TextArea
                      style={{ resize: 'none', height: 'auto' }}
                      rows={2}
                    />
                  }
                </Form.Item>
              </div>
            )}
          </>
        )
      };
    }
  );

  const inventories = data?.data?.inventories?.map(
    (item: Inventory, index: number) => {
      return {
        ...item,
        key: item.id,
        productName: (
          <Form.Item name={['productName', index]}>
            <Text>{item.product.productName}</Text>
          </Form.Item>
        ),
        deliveredDate: (
          <Form.Item name={['deliveredDate', index]}>
            <Text>{formatDateTime(item.deliveredDt)}</Text>
          </Form.Item>
        ),
        location: (
          <Form.Item name={['location', index]}>
            <Text>{item.location}</Text>
          </Form.Item>
        ),
        estimatedQuantity: (
          <Form.Item name={['estimatedQuantity', index]}>
            <Text>{item.estimatedQuantity}</Text>
          </Form.Item>
        ),
        deliveredQuantity: (
          <Form.Item name={['deliveredQuantity', index]}>
            <Text>{item.deliveredQuantity}</Text>
          </Form.Item>
        ),
        availableQuantity: (
          <Form.Item name={['availableQuantity', index]}>
            <Text>{item.availableQuantity}</Text>
          </Form.Item>
        ),
        unavailableQuantity: (
          <Form.Item name={['unavailableQuantity', index]}>
            <Text>{item.unAvailableQuantity}</Text>
          </Form.Item>
        ),
        inspectionResult: (
          <>
            {!item.otherResultDetail && (
              <Form.Item name={['inspectionResult', index]}>
                <Text>{item.inspectionResult}</Text>
              </Form.Item>
            )}
            {item.otherResultDetail && (
              <Form.Item
                name={['otherReason', index]}
                rules={[
                  { required: true, message: 'Input inspection result!' }
                ]}
              >
                <Text>{item.otherResultDetail}</Text>
              </Form.Item>
            )}
          </>
        )
      };
    }
  );

  const editData: DataType[] = data?.data?.inventories?.map(
    (item: Inventory, index: number) => {
      return {
        ...item,
        key: item.id,
        id: item.id,
        productName: (
          <Form.Item name={['productName', index]}>
            <Text>{item.product.productName}</Text>
          </Form.Item>
        ),
        deliveredDate: (
          <Form.Item
            name={['deliveredDate', index]}
            rules={[{ required: true, message: 'Input delivered date!' }]}
          >
            <DatePicker
              placeholder="YYYY.MM.DD 00:00:00"
              defaultValue={moment(item.deliveredDt)}
            />
          </Form.Item>
        ),
        location: (
          <Form.Item
            name={['location', index]}
            rules={[{ required: true, message: 'Input location!' }]}
          >
            <Input defaultValue={item.location} />
          </Form.Item>
        ),
        estimatedQuantity: (
          <Form.Item name={['estimatedQuantity', index]}>
            <InputNumber
              min={0}
              pattern="^[0-9]"
              defaultValue={item.estimatedQuantity}
            />
          </Form.Item>
        ),
        deliveredQuantity: (
          <Form.Item
            name={['deliveredQuantity', index]}
            rules={[
              { required: true, message: 'Input positive delivered quantity!' }
            ]}
          >
            <InputNumber min={0} defaultValue={item.deliveredQuantity} />
          </Form.Item>
        ),
        availableQuantity: (
          <Form.Item
            name={['availableQuantity', index]}
            rules={[
              { required: true, message: 'Input positive available quantity!' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (
                    value >
                    getFieldValue(['deliveredQuantity', index]) -
                      getFieldValue(['unavailableQuantity', index])
                  ) {
                    return Promise.reject(
                      new Error(
                        'Unavailable Quantity must be less than Delivered Quantity - Available Quantity'
                      )
                    );
                  } else {
                    return Promise.resolve();
                  }
                }
              })
            ]}
          >
            <InputNumber min={0} defaultValue={item.availableQuantity} />
          </Form.Item>
        ),
        unavailableQuantity: (
          <Form.Item
            name={['unavailableQuantity', index]}
            rules={[
              {
                required: true,
                message: 'Input positive unavailable quantity!'
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (
                    value >
                    getFieldValue(['deliveredQuantity', index]) -
                      getFieldValue(['availableQuantity', index])
                  ) {
                    return Promise.reject(
                      new Error(
                        'Available Quantity must be less than Delivered Quantity - unavailable Quantity'
                      )
                    );
                  } else {
                    return Promise.resolve();
                  }
                }
              })
            ]}
          >
            <InputNumber min={0} defaultValue={item.unAvailableQuantity} />
          </Form.Item>
        ),

        inspectionResult: (
          <>
            <Form.Item
              name={['inspectionResult', index]}
              rules={[{ required: true, message: 'Input inspection result!' }]}
            >
              <Select
                defaultValue={item.inspectionResult}
                onChange={(value, options) =>
                  handleOnChange(value, options, index)
                }
              >
                <Option value="defective">Defective</Option>
                <Option value="Quantity dismatch">Quantity mismatch</Option>
                <Option value="None">None</Option>
                <Option value="Others">Others</Option>
              </Select>
            </Form.Item>
            {other.includes(index) && (
              <div style={{ marginTop: '20px' }}>
                <Form.Item
                  name={['otherReason', index]}
                  rules={[
                    { required: true, message: 'Input inspection result!' },
                    {
                      max: 30,
                      message: `Input must be less than 30 characters!`
                    }
                  ]}
                >
                  {
                    <Input.TextArea
                      style={{ resize: 'none', height: 'auto' }}
                      rows={2}
                    />
                  }
                </Form.Item>
              </div>
            )}
          </>
        )
      };
    }
  );

  const save = async () => {
    const dataUpdate: any = [];
    data?.data?.inventories?.forEach((item: any, index: number) => {
      dataUpdate.push({
        id: item.id,
        deliveredDate: form
          .getFieldValue('deliveredDate')
          [index].toDate()
          .toISOString(),
        location: form.getFieldValue('location')[index],
        estimatedQuantity: form.getFieldValue('estimatedQuantity')[index],
        deliveredQuantity: form.getFieldValue('deliveredQuantity')[index],
        availableQuantity: form.getFieldValue('availableQuantity')[index],
        unavailableQuantity: form.getFieldValue('unavailableQuantity')[index],
        inspectionResult: form.getFieldValue('inspectionResult')[index]
      });
    });

    await inboundService.updateInventories(dataUpdate, commentId);

    editComplete();
  };

  useEffect(() => {
    const value = {
      id: [],
      deliveredDate: [],
      location: [],
      estimatedQuantity: [],
      deliveredQuantity: [],
      availableQuantity: [],
      unavailableQuantity: [],
      inspectionResult: []
    };
    data?.data?.inventories?.forEach((item: any) => {
      // @ts-ignore
      value.id.push(item.id);
      // @ts-ignore
      value.deliveredDate.push(moment(item.deliveredDt));
      // @ts-ignore
      value.location.push(item.location);
      // @ts-ignore
      value.estimatedQuantity.push(item.estimatedQuantity);
      // @ts-ignore
      value.deliveredQuantity.push(item.deliveredQuantity);
      // @ts-ignore
      value.availableQuantity.push(item.availableQuantity);
      // @ts-ignore
      value.unavailableQuantity.push(item.unAvailableQuantity);
      // @ts-ignore
      value.inspectionResult.push(item.inspectionResult);
    });

    form.setFieldsValue(value);
  }, []);

  return (
    <>
      <Spin spinning={completeLoading} className="loading-forgot">
        <Form form={form} onFinish={completeHandle}>
          <Table
            rowKey={(record) => record.id}
            className="TableComplete warehouse-table"
            columns={columns}
            dataSource={
              data?.data?.status === 'Delivered'
                ? canEdit
                  ? editData
                  : inventories
                : dataInfo
            }
            pagination={false}
            style={{ marginBottom: '20px' }}
          />
          {data?.data?.status === 'Approved' && (
            <Button
              type="primary"
              style={{
                width: '95px',
                marginLeft: 'auto',
                display: 'block',
                background: '#2b2c51'
              }}
              className="approve-button"
              htmlType="submit"
            >
              Save
            </Button>
          )}
          {canEdit && (
            <Button
              type="primary"
              style={{
                width: '95px',
                marginLeft: 'auto',
                display: 'block',
                background: '#2b2c51'
              }}
              className="approve-button"
              onClick={() => save()}
            >
              Save
            </Button>
          )}
        </Form>
        <Popup
          visible={showModal}
          styleBackground="white"
          styleColor="#2A2D51"
          title="Complete"
          text="Do you want to complete this inbound?"
          action_oke={handleOk}
          action_cancel={handleCancel}
        />
      </Spin>
    </>
  );
};

export default TableComplete;
